var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "panel panel-basic",
      class: [_vm.collapsable ? "collapsable" : "", _vm.panelClass],
      attrs: { id: _vm.id }
    },
    [
      _vm.collapsable
        ? _c(
            "div",
            {
              staticClass: "panel-heading",
              on: {
                click: function($event) {
                  _vm.showBody = !_vm.showBody
                }
              }
            },
            [
              _c(
                "h2",
                { staticClass: "panel-title" },
                [
                  _vm._t("title", [
                    _vm._t("icon", [
                      !!_vm.iconClass
                        ? _c("font-awesome-icon", {
                            attrs: {
                              icon: _vm.iconClass,
                              "aria-hidden": "true"
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("span", { domProps: { innerHTML: _vm._s(_vm.title) } }),
                    _vm._v(" "),
                    _vm.helpText
                      ? _c("i", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: {
                                content: "" + _vm.helpText,
                                trigger: "hover click"
                              },
                              expression:
                                "{content: `${helpText}`, trigger: 'hover click'}",
                              modifiers: { "top-center": true }
                            }
                          ],
                          staticClass: "fa fa-info-circle"
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasBadge && !!_vm.badgeContent
                      ? _c(
                          "span",
                          { staticClass: "badge", class: _vm.badgeClass },
                          [_vm._v(_vm._s(_vm.badgeContent))]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.useCollapseExpandCarrots
                    ? [
                        _vm.showBody
                          ? _c("font-awesome-icon", {
                              staticStyle: {
                                position: "absolute",
                                right: "12px",
                                color: "#0E76BD"
                              },
                              attrs: { icon: "caret-up" }
                            })
                          : _c("font-awesome-icon", {
                              staticStyle: {
                                position: "absolute",
                                right: "12px",
                                color: "#0E76BD"
                              },
                              attrs: { icon: "caret-down" }
                            })
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          )
        : _c("div", { staticClass: "panel-heading", class: _vm.badgeClass }, [
            _c(
              "h2",
              { staticClass: "panel-title" },
              [
                _vm._t("title", [
                  _vm._t("icon", [
                    !!_vm.iconClass
                      ? _c("font-awesome-icon", {
                          attrs: { icon: _vm.iconClass, "aria-hidden": "true" }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("span", { domProps: { innerHTML: _vm._s(_vm.title) } }),
                  _vm._v(" "),
                  _vm.helpText
                    ? _c("i", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.top-center",
                            value: {
                              content: "" + _vm.helpText,
                              trigger: "hover click"
                            },
                            expression:
                              "{content: `${helpText}`, trigger: 'hover click'}",
                            modifiers: { "top-center": true }
                          }
                        ],
                        staticClass: "fa fa-info-circle"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasBadge
                    ? _c("span", { staticClass: "badge" }, [
                        _vm._v(_vm._s(_vm.badgeContent))
                      ])
                    : _vm._e()
                ])
              ],
              2
            )
          ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showBody,
              expression: "showBody"
            }
          ],
          staticClass: "panel-body",
          style: { "max-height": _vm.maxHeight + "px", overflow: _vm.overflow },
          attrs: { id: _vm.bodyID }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.showFooter
        ? _c(
            "div",
            { staticClass: "panel-footer" },
            [_vm._t("panel-footer")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }